import React from 'react';
export function EliteSection() {
  return <section className="w-full bg-[#1a0f00] py-16 px-4" data-id="element-74">
      <div className="max-w-4xl mx-auto" data-id="element-75">
        <div className="text-center mb-10" data-id="element-76">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-4" data-id="element-77">
            🏀 ¿QUÉ AGREGA EL{' '}
            <span className="text-[#F97316]" data-id="element-78">KIT TÁCTICO PRO™</span>?
          </h2>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto" data-id="element-79">
            El sistema visual que hace que tus jugadores entiendan el sistema en
            segundos
          </p>
        </div>

        {/* Comparison Table */}
        <div className="bg-black border border-[#F97316]/30 rounded-2xl overflow-hidden mb-12" data-id="element-80">
          <div className="grid grid-cols-1 sm:grid-cols-3 bg-[#0d0700] border-b border-[#F97316]/30" data-id="element-81">
            <div className="p-4 font-bold text-white hidden sm:block" data-id="element-82">
              Situación
            </div>
            <div className="p-4 font-bold text-gray-400 text-center border-l border-[#F97316]/30" data-id="element-83">
              Sin Kit Táctico Pro
            </div>
            <div className="p-4 font-bold text-[#F97316] text-center border-l border-[#F97316]/30" data-id="element-84">
              Con Kit Táctico Pro
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-85">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-86">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-87">
                Situación:
              </span>
              Tu pizarra
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-88">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-89">
                Sin Kit Táctico Pro:
              </span>
              Líneas confusas
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#F97316]/5" data-id="element-90">
              <span className="sm:hidden font-bold text-[#F97316] block mb-1" data-id="element-91">
                Con Kit Táctico Pro:
              </span>
              12 diagramas HD en el TO listos para mostrar
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-92">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-93">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-94">
                Situación:
              </span>
              Explicar el sistema
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-95">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-96">
                Sin Kit Táctico Pro:
              </span>
              "No, así... esperen... acá va el 4..."
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#F97316]/5" data-id="element-97">
              <span className="sm:hidden font-bold text-[#F97316] block mb-1" data-id="element-98">
                Con Kit Táctico Pro:
              </span>
              Mostrás el gráfico y en 10 seg entienden
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-99">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-100">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-101">
                Situación:
              </span>
              Comunicación en el partido
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-102">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-103">
                Sin Kit Táctico Pro:
              </span>
              Gritar instrucciones que no se escuchan
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#F97316]/5" data-id="element-104">
              <span className="sm:hidden font-bold text-[#F97316] block mb-1" data-id="element-105">
                Con Kit Táctico Pro:
              </span>
              20 señales manuales acordadas con el equipo
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-106">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-107">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-108">
                Situación:
              </span>
              Análisis post-partido
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-109">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-110">
                Sin Kit Táctico Pro:
              </span>
              Sin datos ni video
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#F97316]/5" data-id="element-111">
              <span className="sm:hidden font-bold text-[#F97316] block mb-1" data-id="element-112">
                Con Kit Táctico Pro:
              </span>
              Protocolo de 3 clips con el celular
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-113">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-114">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-115">
                Situación:
              </span>
              Presentarte ante el club
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-116">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-117">
                Sin Kit Táctico Pro:
              </span>
              Sin sistema visible
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#F97316]/5" data-id="element-118">
              <span className="sm:hidden font-bold text-[#F97316] block mb-1" data-id="element-119">
                Con Kit Táctico Pro:
              </span>
              Dashboard, informe mensual visual
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3" data-id="element-120">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-121">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-122">
                Situación:
              </span>
              Motivar al jugador de banco
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-123">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-124">
                Sin Kit Táctico Pro:
              </span>
              Charla genérica
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#F97316]/5" data-id="element-125">
              <span className="sm:hidden font-bold text-[#F97316] block mb-1" data-id="element-126">
                Con Kit Táctico Pro:
              </span>
              Tarjeta individual con su nombre y rol
            </div>
          </div>
        </div>

        {/* Features List */}
        <h3 className="text-2xl font-black text-white text-center mb-8" data-id="element-127">
          ✅ KIT TÁCTICO PRO™ INCLUYE:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-128">
          <div className="bg-black border border-[#F97316]/20 rounded-xl p-5" data-id="element-129">
            <h4 className="text-[#F97316] font-bold text-lg mb-2" data-id="element-130">
              🎯 Módulo 1 — El Playbook Visual
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-131">
              12 sistemas del MegaPack diagramados en HD. Imprimí, plastificá,
              mostrá en el tiempo muerto.
            </p>
          </div>
          <div className="bg-black border border-[#F97316]/20 rounded-xl p-5" data-id="element-132">
            <h4 className="text-[#F97316] font-bold text-lg mb-2" data-id="element-133">
              📋 Módulo 2 — Pizarras Tácticas Imprimibles
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-134">
              15 diseños distintos. Cancha completa, media cancha, zona de tiro,
              half time board, rotaciones. Plastificadas = pizarra profesional a
              costo mínimo.
            </p>
          </div>
          <div className="bg-black border border-[#F97316]/20 rounded-xl p-5" data-id="element-135">
            <h4 className="text-[#F97316] font-bold text-lg mb-2" data-id="element-136">
              🤟 Módulo 3 — Sistema de Señales Visuales
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-137">
              20 señales manuales entre el DT y el base. El rival las ve. No las
              entiende.
            </p>
          </div>
          <div className="bg-black border border-[#F97316]/20 rounded-xl p-5" data-id="element-138">
            <h4 className="text-[#F97316] font-bold text-lg mb-2" data-id="element-139">
              📱 Módulo 4 — Video-Scouting Casero
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-140">
              3 clips de 15 segundos con el celular = análisis completo.
              Protocolo exacto: qué grabar, qué buscar, cómo mostrarlo.
            </p>
          </div>
          <div className="bg-black border border-[#F97316]/20 rounded-xl p-5" data-id="element-141">
            <h4 className="text-[#F97316] font-bold text-lg mb-2" data-id="element-142">
              🃏 Módulo 5 — Tarjetas de Scout Individual
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-143">
              Una tarjeta con el nombre del jugador, su rol y sus 2 objetivos
              del partido. El compromiso sube 200%.
            </p>
          </div>
          <div className="bg-black border border-[#F97316]/20 rounded-xl p-5" data-id="element-144">
            <h4 className="text-[#F97316] font-bold text-lg mb-2" data-id="element-145">
              🔥 Módulo 6 — Mapa de Calor del Rival
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-146">
              Observás 20 minutos al rival y sabés exactamente dónde ataca y
              cómo defenderlo.
            </p>
          </div>
          <div className="bg-black border border-[#F97316]/20 rounded-xl p-5 md:col-span-2" data-id="element-147">
            <h4 className="text-[#F97316] font-bold text-lg mb-2" data-id="element-148">
              📊 Módulo 7 — Presentación Profesional al Club
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-149">
              Templates de presentación de temporada e informe mensual para
              hablar con directivos como un DT profesional.
            </p>
          </div>
        </div>
      </div>
    </section>;
}